import Player from '@vimeo/player';

// Event Handler Functions
const toggleSound = (heroVideo, videoTooltip, videoMuteButton) => {
    heroVideo.getMuted()
        .then((muted) => {
            const sound = !muted;
            heroVideo.setMuted(sound);
            if (videoTooltip) {
                const soundStateText = sound ? 'Sound off' : 'Sound on';
                videoTooltip.textContent = soundStateText;
            }
            if (videoMuteButton) {
                videoMuteButton.classList.toggle('mute');
            }
        });
};

const restartVideo = (heroVideo) => {
    heroVideo.setCurrentTime(0).catch((e) => console.error(e));
};

function handleMouseMove(videoTooltip, heroContainer) {
    return function(e) {
        if (heroContainer && videoTooltip) {
            const boundingRect = heroContainer.getBoundingClientRect();
            videoTooltip.style.left = `${e.clientX - boundingRect.left + 10}px`;
            videoTooltip.style.top = `${e.clientY - boundingRect.top + 10}px`;
        } else {
            console.log('heroContainer or videoTooltip is undefined or null');
        }
    }
}

export const homeHeroVideoActions = () => {
    const heroVideoOverflowContainer = document.querySelector('#home-video .home-video__overflow');

    // Verify if container exists
    if (!heroVideoOverflowContainer) return;

    // Construct the Player
    const heroVideo = new Player('home-video', {
        id: 919094940, //video id
        autoplay: true,
        muted: true,
        byline: false,
        chromecast: false,
        controls: false,
        responsive: true,
        title: false,
        vimeo_logo: false,
        loop: true,
        loading:'lazy',
        background: '1'
    });

    // Define IDs for interaction components
    const videoItems = ['restart', 'mute', 'tooltip', 'pause'].reduce((acc, cur) => {
        acc[cur] = document.getElementById(`home-hero__video-${cur}`);
        return acc;
    }, {});
    const { restart: videoRestartButton, mute: videoMuteButton, tooltip: videoTooltip, pause: videoPauseButton } = videoItems;

    let isPaused = false;

    // Check if elements exist before attaching event listeners
    if (videoTooltip) {
        const actionHandleMouseMove = handleMouseMove(videoTooltip, heroVideoOverflowContainer);
        heroVideoOverflowContainer.addEventListener('mousemove', actionHandleMouseMove);

        const actionToggleSoundOnClick = () => toggleSound(heroVideo, videoTooltip, videoMuteButton);
        heroVideoOverflowContainer.addEventListener('click', actionToggleSoundOnClick);
    }

    if (videoMuteButton) {
        const actionToggleSound = () => toggleSound(heroVideo, videoTooltip, videoMuteButton);
        videoMuteButton.addEventListener('click', actionToggleSound);
    }

    if (videoRestartButton) {
        const actionRestartVideo = () => restartVideo(heroVideo);
        videoRestartButton.addEventListener('click', actionRestartVideo);
    }

    if (videoPauseButton) {
        const togglePause = () => {
            isPaused = !isPaused;
            videoPauseButton.classList.toggle('play');
            isPaused ? heroVideo.play() : heroVideo.pause();
        }

        // Toggle pause/play video on button click
        videoPauseButton.addEventListener('click', togglePause);
    }
};